
    const data = {"name":"src/core/icons/chat-outline","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M12 3C6.5 3 2 6.58 2 11a7.218 7.218 0 0 0 2.75 5.5c0 .6-.42 2.17-2.75 4.5 2.37-.11 4.64-1 6.47-2.5 1.14.33 2.34.5 3.53.5 5.5 0 10-3.58 10-8s-4.5-8-10-8m0 14c-4.42 0-8-2.69-8-6s3.58-6 8-6 8 2.69 8 6-3.58 6-8 6Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            